import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";
import {CommsPlanSectionTypes} from "root/DataFunctions/Constants";
import {FormSectionTypes} from "root/Wieldy/ApplicationModules/Child/Body/Agreements/FormComponents/AutoFormBase";

export const getCommunicationsPlansForAdoptee = (child_uid, onCompleteFunc) => {

    if (child_uid == null)
    {
        throw new Error('Invalid Child ID passed to getChildDetails')
    }
    else
    {
        const url = Globals.APIFolder + '/child/' + child_uid + '/commsplan';

        getDataWithPromise(url, 'GET', {}).then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
    }
};

export const createCommunicationsPlansForAdoptee = (child_uid, formData, onCompleteFunc) => {

    if (child_uid == null)
    {
        throw new Error('Invalid Child ID passed to getChildDetails')
    }
    else
    {
        const url = Globals.APIFolder + '/child/' + child_uid + '/commsplan';

        getDataWithPromise(url, 'POST', formData ).then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
    }
};

export const getCommunicationsPlanDetails = (child_uid, enc_communications_plan_id, perform_grouping,  onCompleteFunc) => {

    const grouping = perform_grouping ? '&grouping=true' : '' ;

    if (enc_communications_plan_id == null)
    {
        throw new Error('Invalid ID passed to enc_communications_plan_id')
    }
    else
    {
        const url = Globals.APIFolder + '/child/' + child_uid + '/commsplan/' + enc_communications_plan_id + '?include-items&include-connections' + grouping;

        getDataWithPromise(url, 'GET', {}).then(data =>
        {
            onCompleteFunc(data);
        })
            .catch((jqXHR, textStatus, error) =>
            {
                handleAjaxError(jqXHR, textStatus, error);
            });
    }
};

export const updateCommunicationsPlanDetails = (child_uid, enc_communications_plan_id, formData, onCompleteFunc) => {

    if (enc_communications_plan_id == null)
    {
        throw new Error('Invalid ID passed to enc_communications_plan_id')
    }
    else
    {
        const url = Globals.APIFolder + '/child/' + child_uid + '/commsplan/' + enc_communications_plan_id ;

        getDataWithPromise(url, 'PUT', formData).then(data =>
        {
            onCompleteFunc(data);
        })
            .catch((jqXHR, textStatus, error) =>
            {
                handleAjaxError(jqXHR, textStatus, error);
            });
    }
};

const getPrefixForType = ( itemType ) =>
{
    switch (itemType)
    {
        case CommsPlanSectionTypes.INPUT:
            return "01" ;
        case CommsPlanSectionTypes.TEXTAREA:
            return "02" ;
        case CommsPlanSectionTypes.TOGGLE:
            return "03" ;
        default:
            return "99" ;
    }
}

// Generate an unique item name given as cpsp_id and cpr_id
// This name format is i,mportant as it is parsed by the form submission functions at the server side
export const itemName = ( cpsp_id, cpr_id, itemType ) =>
{
    return getPrefixForType(itemType) + '_cpsp_' + cpsp_id + '_cpr_' + cpr_id ;
}

export const mapDataFieldsForFormFields = ( sections ) =>
{
    const formFields = sections.reduce ( (cur, rec) =>
    {
        const questions = rec.questions.reduce ((cq, rq ) =>
        {
            const sectionType = +(rq.section_type) ;

            switch ( sectionType )
            {
                case FormSectionTypes.INPUT:
                case FormSectionTypes.TEXTAREA:
                    cq[itemName(rq.cpsp_id, rq.cpr_id, sectionType )] = rq.response_text ;
                    break ;
                case CommsPlanSectionTypes.TOGGLE:
                    cq[itemName(rq.cpsp_id, rq.cpr_id, sectionType )] = +(rq.response_bool) === 1 ;
                    break ;
                case CommsPlanSectionTypes.LIFESTORY:
                    cq.is_contributor = true  ;
                    break ;
                case CommsPlanSectionTypes.MESSAGING:
                    cq.is_messager = true ;
                    cq.is_messaging_bidirectional = true ;
                    cq.is_letterbox_required = true ;
                    break ;
            }

            return cq ;

        }, {} ) ;

        cur = { ...cur, ...questions } ;

        return cur ;
    }, {}) ;

    return formFields ;
}

const periodicity_text = ( periodicity_id ) =>
{

}
export const mapDataFieldsForPDF = ( sections ) =>
{
    const formFields = sections.reduce ( (cur, rec) =>
    {
        const questions = rec.questions.reduce ((cq, rq ) =>
        {
            const sectionType = +(rq.section_type) ;

            switch ( sectionType )
            {
                case CommsPlanSectionTypes.LIFESTORY:
                    cq.is_contributor = true  ;
                    break ;
                case CommsPlanSectionTypes.MESSAGING:
                    cq.is_messager = true ;
                    cq.is_messaging_bidirectional = true ;
                    cq.is_letterbox_required = true ;
                    break ;
                default:

                    const fieldType = rq.field_type ;

                    switch ( fieldType )
                    {
                        case FormSectionTypes.INPUT:
                        case FormSectionTypes.TEXTAREA:
                            cq[rq.data_item_name] = { heading: rq.heading, response: rq.response_text, type: 'text' } ;
                            break ;
                        case FormSectionTypes.TOGGLE:
                        case FormSectionTypes.CHECKBOX:
                            const boolValue = +(rq.response_bool) === 1  ;
                            const yesNoValue = +(rq.response_bool) === 1 ? 'Yes' : 'No' ;
                            cq[rq.friendly_name]  = { heading: rq.heading, response: +(rq.response_bool), type: 'bool', bool: boolValue, yes_no: yesNoValue } ;
                            break ;
                        case FormSectionTypes.MEDIA_EXCHANGE:
                            const boolValueMedia = +(rq.response_bool) === 1  ;
                            const yesNoValueMedia = +(rq.response_bool) === 1 ? 'Yes' : 'No' ;
                            cq[rq.friendly_name]  = { heading: rq.heading,
                                                      response: +(rq.response_bool),
                                                      type: 'media',
                                                      bool: boolValueMedia,
                                                      yes_no: yesNoValueMedia,
                                                      periodicity_type: +(rq.periodicity_id),
                                                      periodicity_text: rq.periodicity_description,
                                                      max_allowed_count: +rq.max_allowed_count } ;
                            break ;
                    }
            }

            return cq ;

        }, {} ) ;

        cur = { ...cur, ...questions } ;

        return cur ;
    }, {}) ;

    return formFields ;
}

const numberFriendly = ( count ) =>
{
    switch ( count )
    {
        case 1:
            return "One" ;
        case 2:
            return "Two" ;
        case 3:
            return "Three" ;
        case 4:
            return "Four" ;
        case 5:
            return "Five" ;
        default:
            return count ;
    }
}

const periodFriendly = ( preiodicity_id, default_text ) =>
{
    switch ( preiodicity_id )
    {
        case 1:
            return "each year" ;
        case 2:
            return "every six months" ;
        case 3:
            return "each month" ;
        case 4:
            return "every 3 months (quarterly)" ;
        case 5:
            return "each week" ;
        default:
            return default_text;
    }
}

const mediaResponse = ( rec ) =>
{
    if ( rec.bool === false )
    {
        return "May not be sent" ;
    }
    else
    {
        return numberFriendly ( +rec.max_allowed_count ) + ' may be sent ' + periodFriendly ( +(rec.periodicity_type), rec.periodicity_text ) ;
    }
}

export const getFormTableColumnForDisplay = ( formFields, name ) =>
{
    if ( formFields[name] === undefined )
    {
        console.warn('Undefined data item in form fields : ' + name + ' is not included in the template. Please ensure the form includes this data item')
        return [ 'Undefined: ' + name, '' ] ;
    }

    switch ( formFields[name].type )
    {
        case 'bool' :
            return [ formFields[name].heading, formFields[name].yes_no ] ;
        case 'media' :
            return [ formFields[name].heading, mediaResponse( formFields[name])] ;
        default:
            return [ formFields[name].heading, formFields[name].response ] ;
    }
}

export const getFormTableColumnsForDisplay = ( formFields, names ) =>
{
    return names.map((name) => getFormTableColumnForDisplay(formFields, name) ) ;
}

export const getTableColumnStyles = ( width, c1, c2 ) =>
{
    return  {title: {cellWidth: width * c1, fontStyle: 'bold', fontName: 'helvetica',}, detail: {cellWidth: width * c2}};
}

export const getAdultNames = ( contacts ) =>
{
    const names = contacts.reduce((last, curr, idx, orig) => {
        if ( last === '')
        {
            return curr.connection_firstname + ' ' + curr.connection_surname ;
        }
        else
        {
            if ( idx === ( orig.length - 1 ))
            {
                return last + ' ' + 'and ' + curr.connection_firstname + ' ' + curr.connection_surname ;
            }
            else
            {
                return last + ', ' + curr.connection_firstname + ' ' + curr.connection_surname ;
            }
        }

    }, '' );

    return names ;
}

/**
 * Filter function to return a list of contacts meeting the family_type filter criterion
 *
 * This component accepts one or two AxisWrapper child components containing their respective content
 * and formats the layout of these wrappers according to the passed format.
 *
 * <pre>
 *     E.g. birthParents = filterContactPlanFamilyTypeMembers ( FamilyTypes.BIRTH, contacts ) ;
 * </pre>
 *
 *  @type {array}
 *
 *  @param {FamilyTypes} family_type - Family type ID E,g, FamilyTypes.BIRTH
 *  @param {array} contacts
 *
 *  @returns {array} A filtered array of records meeting the criterion.
 *
 */
export const filterContactPlanFamilyTypeMembers = (family_type, contacts ) =>
{
    return contacts.filter((item) =>
    {
        return +(item.family_type_id) === family_type ;
    })
}

export const getAdultTitles = ( contacts ) =>
{
    const names = contacts.reduce((last, curr, idx, orig) => {
        if ( last === '')
        {
            return curr.name ;
        }
        else
        {
            if ( idx === ( orig.length - 1 ))
            {
                return last + ' ' + 'and ' + curr.name  ;
            }
            else
            {
                return last + ', ' + curr.name  ;
            }
        }

    }, '' );

    return names ;
}

export const getChildNameFromCommsPlan = ( rec ) =>
{
    return rec.child_firstname + ' ' + rec.child_surname ;
}
